import ProgressBar from '../atoms/ProgressBar'
import { useSelector } from 'react-redux'

export default function OrdersProgressBar() {
  const { isRecastActive } = useSelector((state) => state.recast)

  return (
    <div className="p-4 bg-white rounded-md shadow-md">
      <h4>Closed Won Opps</h4>
      <ProgressBar barColor="bg-green-500" completePercent={isRecastActive ? 33 : 5} />
    </div>
  )
}
